/**
 * CSRF Token Helper
 * Legge il token CSRF dal cookie (non httpOnly) impostato dal backend
 */

/**
 * Legge il valore di un cookie per nome
 * @param {string} name - Nome del cookie
 * @returns {string|null} Valore del cookie o null
 */
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? decodeURIComponent(match[2]) : null
}

/**
 * Ottieni il token CSRF dal cookie
 * @returns {string|null}
 */
export const getCsrfToken = () => {
  return getCookie('__Secure-csrf')
}
